import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';

const StoreFinderClickableItem = (_param)=>{
    var { className , variant , children , disabled =false , icon , type ='button'  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "variant",
        "children",
        "disabled",
        "icon",
        "type"
    ]);
    return /*#__PURE__*/ React.createElement("button", swcHelpers.extends({}, rest, {
        type: type,
        disabled: disabled,
        className: classnames('stores-v2-store-finder-item', className, {
            'stores-v2-store-finder-item--list-item': variant === 'list-item',
            'stores-v2-store-finder-item--map-item': variant === 'map-item',
            'stores-v2-store-finder-item--disabled': disabled
        })
    }), icon ? /*#__PURE__*/ React.createElement("div", {
        className: "stores-v2-store-finder-item__icon"
    }, icon) : null, children);
};

export { StoreFinderClickableItem as default };
//# sourceMappingURL=StoreFinderClickableItem.js.map
